import React from 'react';
import AddressFilesView from '../components/AddressFilesView';

export default function ClosingPacks() {
  return (
    <AddressFilesView
      kind="closing-pack"
      title="Closing Packs"
      emptyKindLabel="closing pack"
    />
  );
}
